import { Component, OnInit, Input } from '@angular/core';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import { AppState, ShowRequest } from '../../core';
import { ScoutPath, ScoutPoint } from '../../core/models';

@Component({
  selector: 'app-scout-header',
  templateUrl: './scout-header.component.html',
  styleUrls: ['./scout-header.component.scss']
})
export class ScoutHeaderComponent implements OnInit {

  @Input() scoutTaskDoc : ScoutTaskDoc
  @Input() scoutPath : ScoutPath
  @Input() scoutPoint : ScoutPoint

  scoutPathIndex : number

  constructor(protected appState : AppState) { }

  ngOnInit(): void {
  }

  onShowBuilding() {
    const buildingId = this.scoutTaskDoc?.buildingId
    this.appState.showView.next( new ShowRequest('tab','building', buildingId, this.scoutTaskDoc) )
  }
}
